// src/components/About.js
import React from 'react';
import '../Styles/About.css'; // Make sure your CSS file is correctly imported
import VideoPlayer from './VideoPlayer';
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import images (commented out as they're not currently used)
// import storyImage from '../assets/images/story.jpg';
// import missionImage from '../assets/images/mission.jpg';
// import groupImage from '../assets/images/group.jpg';

function About() {
    return (
        <section className="about-section">
            
            
            {/* Video Section */}
            <div className="about-video-section">
                <VideoPlayer 
                    title="How Edulab UUMS Powers Modern University"
                    useYouTube={true}
                    youtubeId="z0dngkXgs50"
                    className="about-video"
                />
            </div>
            <h2>About Us</h2>
            <div className="about-content">

        
            
                <div className="about-story">
                    <div className="about-icon">
                        <i className="fas fa-history"></i>
                    </div>
                    <h3>Our Story</h3>
                    <p className="about-story-text">Founded in 2010 by Pratik Gandhi and a dedicated team, Edulab has been at the forefront of educational technology, transforming how universities manage their operations and serve their students.</p>
                </div>
                <div className="about-mission">
                    <div className="about-icon">
                        <i className="fas fa-cogs"></i>
                    </div>
                    <h3>ERP Solutions</h3>
                    <p className="about-mission-text">We provide comprehensive ERP software solutions specifically designed for educational institutions, streamlining operations from student enrollment to graduation.</p>
                </div>
                <div className="about-group">
                    <div className="about-icon">
                        <i className="fas fa-university"></i>
                    </div>
                    <h3>University Management</h3>
                    <p className="about-group-text">Our advanced university management systems help institutions digitalize every aspect of campus life, from academic records to student services.</p>
                </div>
            </div>
        </section>
    );
}

export default About;
